import Constants from '@usas/ui-web/utils/Constants';
import { PreCompHttpHelper, BASIC_INITIAL_STATE, NO_DATA_MESSAGE } from '@usas/ui-web/utils/HttpHelper';
import { compareAlphabetical } from '@usas/ui-web/utils/SortingUtils';

const INITIAL_STATE = {
  ...BASIC_INITIAL_STATE,
  dataAsOptionsWithNames: []
};

const getPreCompCurriculums = (state, setState) => {
  if (state.isArrayLoading !== true && !state.message) {
    let newState = {
      ...state,
      isArrayLoading: true,
      isArrayLoaded: false,
      message: 'Loading...'
    };
    setState(newState);

    const url = `/PreCompCurriculum`;
    PreCompHttpHelper(url, 'GET')
      .then((arrayData) => {
        if (!arrayData) {
          throw new Error(NO_DATA_MESSAGE);
        } else {
          arrayData.sort((a, b) => compareAlphabetical(a.curriculumName, b.curriculumName));
          arrayData.unshift({ preCompCurriculumId: Constants.DEFAULT_ID, curriculumName: '--' });
          
          newState = {
            ...newState,
            isArrayLoading: false,
            isArrayLoaded: true,
            arrayData,
            dataAsOptionsWithNames: arrayData.map(x => { return { id: x.preCompCurriculumId, name: x.curriculumName } }),
            message: ''
          };
          setState(newState);
        }
      })
      .catch((e) => {
        const message = e && e.message ? e.message : NO_DATA_MESSAGE;
        setState({
          ...newState,
          isArrayLoading: false,
          isArrayLoaded: false,
          message: message
        });
      });
  }
};

const PreCompCurriculumData = {
  INITIAL_STATE,
  getPreCompCurriculums
};

export default PreCompCurriculumData;